import { AnimatePresence, motion } from "motion/react";
import { Component, ReactNode } from "react";
import { SnackbarErrorIcon } from "../assets/icons";

interface FormFieldErrorMessageProps {
  errorMessage: string | null;
}

export class FormFieldErrorMessage extends Component<FormFieldErrorMessageProps> {
  render(): ReactNode {
    const { errorMessage } = this.props;

    return (
      <AnimatePresence>
        {errorMessage && (
          <motion.div
            initial={{ y: -15, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -15, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="flex gap-1"
          >
            <SnackbarErrorIcon className="fill-error min-w-4 min-h-4 max-w-4 max-h-4 mt-1" />
            <p className="text-sm text-error">{errorMessage}</p>
          </motion.div>
        )}
      </AnimatePresence>
    );
  }
}
